export default __webpack_public_path__ + "static/media/episode-07.a6ae73c8.webp";